var exports = {
  "Fk": "xaf9ae18d--68c088--slidein",
  "kL": "xaf9ae18d--68c088--container",
  "y_": "xaf9ae18d--68c088--pin",
  "Pf": "xaf9ae18d--68c088--label",
};

module.exports = exports;
